<template>
  <span
    class="tw-inline-flex tw-items-center tw-justify-center tw-leading-none"
  >
    <svg
      class="tw-block tw-h-[22px] tw-w-[22px] tw-shrink-0 md:tw-h-[25px] md:tw-w-[25px] md:tw-translate-x-[0.5px] md:tw-translate-y-[-0.5px]"
      viewBox="0 0 22 22"
      xmlns="http://www.w3.org/2000/svg"
      :aria-hidden="ariaHidden"
      focusable="false"
    >
      <path
        d="M18.3974 4.70226C17.5008 3.80784 16.2864 3.30486 15.0199 3.30332C13.7534 3.30177 12.5379 3.80178 11.639 4.69401L10.5599 5.69639L9.47999 4.69071C8.58136 3.7946 7.36356 3.29217 6.09449 3.29395C4.82542 3.29573 3.60904 3.80157 2.71293 4.7002C1.81682 5.59882 1.31439 6.81662 1.31617 8.08569C1.31795 9.35476 1.82379 10.5712 2.72242 11.4673L10.0938 18.9467C10.5599 19.4166 10.5599 19.4166 11.0343 18.9467L18.3974 11.4673C19.2942 10.57 19.7979 9.35333 19.7979 8.08476C19.7979 6.81619 19.2942 5.59954 18.3974 4.70226Z"
        fill-rule="evenodd"
        :fill="fill"
        :stroke="stroke"
        stroke-width="1.5"
        class="tw-transition-all tw-duration-200"
      />
    </svg>
  </span>
</template>

<script>
export default {
  name: 'Shortlists',
  props: {
    strokeColor: {
      type: Boolean,
      default: false,
    },
    hasShortlistedProperties: {
      type: Boolean,
      default: false,
    },
    ariaHidden: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    fill() {
      return 'none';
    },
    stroke() {
      return this.strokeColor ? '#ffffff' : '#00a2e1';
    },
  },
};
</script>
